export default {
  chartColor1: '#D1A617',
  chartColor2: '#5A657D',
  chartColor3: '#A5735E',
  chartColor4: '#A5965F',
  chartColor5: '#B8B2B2',
  chartColor6: '#E8E8E8',
  chartColor7: '#B3BBCB',
  graph: {
    blue: '#40A9FF', // old 0BA5EC
    gray: '#E0E0E0',
    orange: '#9254DE' // old F79009 9254DE
  },
  theme: {
    black: '#000',
    white: '#FFF',
    darkGray: '#767676',
    gray: '#6A6A6A',
    blueish: '',
    purple: '#9254DE'
  }
}
